import {
  ComponentDto,
  CreateOnsiteInjectionDto,
  OnsiteEditDto,
} from "@intelligems/ig-types";
import { getComponentHandler } from "@src/store/slices/experienceBuilder/common/utils/modHandlerRegistry";
import { imageModHandler } from "@src/store/slices/experienceBuilder/basicMod/utils/imageModHandler";
import { injectionModHandler } from "@src/store/slices/experienceBuilder/basicMod/utils/injectionModHandler";
import { layoutModHandler } from "@src/store/slices/experienceBuilder/basicMod/utils/layoutModHandler";
import { textModHandler } from "@src/store/slices/experienceBuilder/basicMod/utils/textModHandler";
import { bannerComponentHandler } from "@src/store/slices/experienceBuilder/component/utils/bannerComponentHandler";
import { genericComponentHandler } from "@src/store/slices/experienceBuilder/component/utils/genericComponentHandler";
import { imageComponentHandler } from "@src/store/slices/experienceBuilder/component/utils/imageComponentHandler";
import { textComponentHandler } from "@src/store/slices/experienceBuilder/component/utils/textComponentHandler";
import {
  EmbeddedMod,
  ModConversion,
} from "@src/store/slices/experienceBuilder/types";

function getComponentTag(html: string): string | undefined {
  const match = html.match(/<(ig-(?:\w+-)?component)/);
  return match?.[1];
}

function convertOnsiteEdit(edit: OnsiteEditDto): EmbeddedMod {
  const conversion: ModConversion = { type: "onsiteEdit", dto: edit };
  const tag = getComponentTag(edit.replace);
  switch (tag) {
    case "ig-text-component":
      return textComponentHandler.convertTo(conversion);
    case "ig-image-component":
      return imageComponentHandler.convertTo(conversion);
    case "ig-banner-component":
      return bannerComponentHandler.convertTo(conversion);
    case "ig-component":
      return genericComponentHandler.convertTo(conversion);
    default:
      if (edit.onsiteEditType === "image" || edit.isImage) {
        return imageModHandler.convertTo(conversion);
      }
      if (edit.onsiteEditType === "text") {
        return textModHandler.convertTo(conversion);
      }
      return layoutModHandler.convertTo(conversion);
  }
}

export const toMods = (options: {
  onsiteEdits: OnsiteEditDto[];
  onsiteInjections: CreateOnsiteInjectionDto[];
  components?: ComponentDto[];
}) => {
  const mods: EmbeddedMod[] = [];

  for (const edit of options.onsiteEdits) {
    mods.push(convertOnsiteEdit(edit));
  }
  for (const injection of options.onsiteInjections) {
    mods.push(
      injectionModHandler.convertTo({ type: "onsiteInjection", dto: injection })
    );
  }
  for (const component of options.components ?? []) {
    // Dispatch by `config.type` through the registry, mirroring `fromMods`'s
    // `getModHandler(mod)` — bundle etc. register a handler instead of a branch.
    mods.push(
      getComponentHandler(component.config.type).convertTo({
        type: "component",
        dto: component,
      })
    );
  }

  return mods;
};
